export const TOGGLE_PHONE_NUMBER_AUTH = 'TOGGLE_PHONE_NUMBER_AUTH';
export const SET_AUTH_TYPE = 'SET_AUTH_TYPE';
